import { useCallback, useEffect, useState } from 'react';
import { featureService } from '../../api/featureService';
import type { IntegrationContent } from '../../lib/integration-content-data';

export type IntegrationContentState =
  | { status: 'loading'; rows: readonly IntegrationContent[] }
  | { status: 'ready'; rows: readonly IntegrationContent[] }
  | { status: 'error'; rows: readonly IntegrationContent[] };

/** Product content has its own loading owner and never blocks connection actions. */
export function useIntegrationContent(enabled = true) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState<IntegrationContentState>({ status: 'loading', rows: [] });
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    setState({ status: 'loading', rows: [] });
    featureService.getIntegrationContent({ forceRefresh: attempt > 0 }).then(rows => {
      if (active) setState({ status: 'ready', rows });
    }).catch(() => {
      if (active) setState({ status: 'error', rows: [] });
    });
    return () => { active = false; };
  }, [attempt, enabled]);
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  return { ...state, retry };
}
